import type { ClarifyFormField } from '../../../types';

export type FieldValue = string | string[];

export const isPicker = (field: ClarifyFormField): boolean =>
  field.type === 'picker' && !!(field.options?.length || field.search);
